import _ from 'lodash';

const isFiltered = (state) =>{
  return !(state.search==='')
}


export default {
  isFiltered,
};
